import AboutUsSectionOne from "../../components/AboutUs/AboutUsSectionOne";
//import AboutUsSectionThree from "../../components/AboutUs/AboutUsSectionThree";
import AboutUsSectionTwo from "../../components/AboutUs/AboutUsSectiontwo";

function AboutUs(){
    return (
        <>
            <AboutUsSectionOne/>
            <AboutUsSectionTwo/>
            {/* <AboutUsSectionThree/> */}
        </>
    );
}

export default AboutUs;